










import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Abilities extends Vue {
  @Prop({ required: true }) data!: string[];
}
